import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Switch, FormControlLabel } from "@mui/material";
import {
    Box,
    Button,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { ContactPersonModel } from 'model/screensModels/membership/ContactPersonModel';
import { useState } from 'react';
import ContactPersonSchema from 'schemas/menu/membershipForm/ContactPersonSchema';
import showAlert, { conformationAlert, messageAlert } from 'services/shared/alert';


const MembershipContactPerson = ({ memberlist, setMemberList }) => {

    const [initialValues, setInitialValues] = useState(new ContactPersonModel())
    const [flag, setFlag] = useState(false)

    const addMember = async (values, setFieldValue, setFieldTouched) => {
        if (values.contactPersonId !== '' && values.contactPersonId !== undefined) {
            updateRecord(values, setFieldValue, setFieldTouched);
        } else {
            addRecord(values, setFieldValue, setFieldTouched);
        }
        setFlag(false);
    }


    const addRecord = async (values, setFieldValue, setFieldTouched) => {
        if ((countNoOfRepresentative() === 0) || (countNoOfRepresentative() === 1 && !values.contactIsrepresentative)) {
            const data = await createData(values.contactPersonId, values.name, values.position, values.phoneNumber, values.email, values.contactPersonImage, values.contactIsrepresentative, values.deleteStatus);
            setMemberList(oldArray => [...oldArray, data])
            resetFieldValue(setFieldValue, setFieldTouched)
        } else {
            await messageAlert("Only One representative allowed", msgTypes.CONFORMATION_ICON.ERROR);
        }
    }

    // const countNoOfRepresentative = () => {
    //     var count = 0
    //     memberlist.map((data: ContactPersonModel) => {
    //         if (data.contactIsrepresentative === true) {
    //             count = count + 1;
    //         }
    //     })
    //     return count;
    // }

    // Helper function
    // Helper: count representatives
    const countNoOfRepresentative = () => {
        return memberlist.filter(m => m.contactIsrepresentative === true).length;
    };

    // Jab contact add/update karte ho us time call karo
    const validateContactPersonForm = () => {
        const repCount = countNoOfRepresentative();

        // agar 2 se zyada representative hai
        if (repCount > 1) {
            showAlert("Only one representative allowed.", "", msgTypes.error, msgTypes.OK_KEY);
            return false;
        }

        // agar 0 representative hai
        if (repCount === 0) {
            showAlert("At least one representative required.", "", msgTypes.error, msgTypes.OK_KEY);
            return false;
        }

        return true;
    };

    const updateRecord = (values: ContactPersonModel, setFieldValue, setFieldTouched) => {
        const updatedList = memberlist.map((data: ContactPersonModel) => {
            if (data.contactPersonId === values.contactPersonId) {
                return {
                    ...data,
                    name: values.name,
                    position: values.position,
                    email: values.email,
                    phoneNumber: values.phoneNumber,
                    contactPersonImage: values.contactPersonImage,
                    contactIsrepresentative: values.contactIsrepresentative,
                    deleteStatus: values.deleteStatus,
                }
            }
            return data;
        });
        setMemberList(updatedList);
        resetFieldValue(setFieldValue, setFieldTouched);
    }


    const resetFieldValue = (setFieldValue, setFieldTouched) => {
        //values.contactPerson.push(data)
        setFieldValue('contactPersonId', '');
        setFieldValue('name', '');
        setFieldTouched('name', false);
        setFieldValue('position', '');
        setFieldTouched('position', false);
        setFieldValue('phoneNumber', '');
        setFieldTouched('phoneNumber', false);
        setFieldValue('email', '');
        setFieldTouched('email', false);
        setFieldValue('contactPersonImage', '');
        setFieldTouched('contactPersonImage', false);
        setFieldValue('contactIsrepresentative', false);
        setFieldTouched('contactIsrepresentative', 0);
        setFieldValue('deleteStatus', false);
        setFieldTouched('deleteStatus', 0);
    }

    const createData = async (contactPersonId, name, position, phoneNumber, email, contactPersonImage, contactIsrepresentative, deleteStatus = false) => {
        return { contactPersonId, name, position, phoneNumber, email, contactPersonImage, contactIsrepresentative, deleteStatus: deleteStatus ?? false };
    }

    const removeMember = async (index) => {
        const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");
        if (deleteFlag) {
            setMemberList([
                ...memberlist.slice(0, index),
                ...memberlist.slice(index + 1)
            ]);
        }
    }

    const editContactPerson = (index: number, member: ContactPersonModel) => {
        setInitialValues(new ContactPersonModel());
        setInitialValues(member);
        setFlag(true)
    }

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={ContactPersonSchema}
                onSubmit={async (values, { resetForm }) => {
                }}
            >
                {({ handleSubmit, isValid, dirty, values, setFieldValue, setFieldTouched }) => (
                    <Form onSubmit={handleSubmit}>
                        <Grid >

                            <div className='member-block-body'>
                                <h1>Contact Person</h1>
                            </div>
                            <div>
                                <div className='row'>
                                    <div className='col-md-6 position-relative'>
                                        <FormikControl
                                            control="textfield"
                                            name="name"
                                            label="Name"
                                            placeholder="Enter Your Name"
                                            requiredField
                                        />
                                    </div>
                                    <div className='col-md-6 position-relative'>
                                        <FormikControl
                                            control="textfield"
                                            name="position"
                                            label="Position / Designation"
                                            placeholder="Enter Your Position / Designation"
                                            requiredField
                                        />
                                    </div>
                                    <div className='col-md-6'>

                                        <div className='col-lg-6 w-100 position-relative'>
                                            <FormikControl
                                                control="phoneInputField"
                                                name="phoneNumber"
                                                label="Phone Number"
                                                placeholder="Enter Your Contact Number"
                                                requiredField
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 position-relative'>
                                        <FormikControl
                                            control="textfield"
                                            name="email"
                                            label="Email Id"
                                            placeholder="Enter Your Email Id"
                                            requiredField
                                        />

                                    </div>
                                    <div className='col-md-6 position-relative'>
                                        <FormikControl
                                            control="uploadImage"
                                            name="contactPersonImageFile"
                                            label="Contact Person Image"
                                            tooltip={[msgTypes.DOCUMENT_TYPE.JPG, msgTypes.DOCUMENT_TYPE.JPEG,
                                            msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                            nameUrl="contactPersonImage"
                                        />
                                        <p className='error-msg-img'>Image dimensions 300x300px & upto 100kb.</p>
                                    </div>
                                    <div className='col-md-6 position-relative'>
                                        <FormikControl
                                            className="radiobutton"
                                            control="radiogroup"
                                            label="Authorized Representative"
                                            name="contactIsrepresentative"

                                            options={[
                                                { key: "Yes", value: true },
                                                { key: "No", value: false },
                                            ]}
                                            requiredField
                                            row
                                            onChange={e => setFieldValue("contactIsrepresentative", e.target.value === "true")}

                                        />
                                    </div>
                                    <div className="col-md-6 position-relative mt-4">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={values.deleteStatus}
                                                    onChange={(e) => setFieldValue("deleteStatus", e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                            label="Delete Status"
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <Box className="btn-member mt-3" display="flex">
                                            <Button
                                                className='btn'
                                                variant="contained"
                                                onClick={(e) => addMember(values, setFieldValue, setFieldTouched)}
                                                disabled={(!dirty || !(isValid) || (memberlist.length >= 5 && values.contactPersonId === ''))}
                                            >
                                                -                                                {flag ? "Update Member" : "Add Member"}
                                            </Button>



                                        </Box>
                                    </div>
                                    {memberlist.length >= 5 && (<div className='text-danger'>Maximum 5 contact members allowed to add. </div>)}
                                </div>

                                <div className='col-12 mt-4 mb-4'>
                                    {memberlist?.length > 0 ?
                                        <Grid className='mui-tables' item xs={12} sm={12}>
                                            <TableContainer className='mui-tables-body' component={Paper}>
                                                <Table sx={{ minWidth: 500 }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>S. No.</TableCell>
                                                            <TableCell>Name</TableCell>
                                                            <TableCell align="right">Position</TableCell>
                                                            <TableCell align="right">Phone Number</TableCell>
                                                            {/* <TableCell align="right">Email</TableCell> */}
                                                            <TableCell align="right">Representative</TableCell>
                                                            <TableCell align="right">Delete Status</TableCell>
                                                            <TableCell align="right">Action</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {memberlist.map((member: ContactPersonModel, index) => (
                                                            <TableRow
                                                                key={index}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >

                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{member.name}</TableCell>
                                                                <TableCell align="right">{member.position}</TableCell>
                                                                <TableCell align="right">{member.phoneNumber}</TableCell>
                                                                <TableCell align="right">{(member.contactIsrepresentative === true || ("" + member.contactIsrepresentative) === 'true') ? "Yes" : "No"}</TableCell>
                                                                <TableCell align="right">
        {member.deleteStatus ? "True" : "False"}</TableCell>
                                                                <TableCell align="right">
                                                                    <EditIcon className='cursor-pointer' onClick={() => { editContactPerson(index, member) }} color="action" />
                                                                    <DeleteIcon className='cursor-pointer' onClick={() => { removeMember(index) }} color="action" />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                        : ""}
                                </div>
                            </div>
                        </Grid>
                    </Form>
                )}
            </Formik>


        </>
    )
}

export default MembershipContactPerson
